"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleJumpNavExpanded = exports.renderJumpNavItems = void 0;
var _react = _interopRequireDefault(require("react"));
var _smoothscrollPolyfill = _interopRequireDefault(require("smoothscroll-polyfill"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const formatNavItemTitle = item => {
  const truncatedItem = item?.length > 16 ? item?.split("", 17)?.join("") + "..." : item;
  return truncatedItem;
};
const renderJumpNavItems = (pageSections, activeNavItem, navType, updateActiveNavItem) => {
  if (navType === "horizontal") {
    return pageSections && pageSections?.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index,
        className: `ter-jump-nav__nav-item ${index === activeNavItem ? "ter-jump-nav__nav-item--active" : ""}`,
        onClick: e => jumpNavClickHandler(e, item?.link, index, updateActiveNavItem)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-jump-nav__link-text"
      }, formatNavItemTitle(item?.title)));
    });
  }
  return pageSections && pageSections?.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: `ter-jump-nav__nav-item ${index === activeNavItem ? "ter-jump-nav__nav-item--active" : ""}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-jump-nav__nav-link",
      onClick: e => jumpNavClickHandler(e, item?.link, index, updateActiveNavItem)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-jump-nav__link-dot"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-jump-nav__link-text"
    }, item?.title)));
  });
};
exports.renderJumpNavItems = renderJumpNavItems;
const jumpNavClickHandler = (e, destination, index, updateActiveNavItem) => {
  e.preventDefault();
  function handleClickNavItem() {
    updateActiveNavItem(index);
  }
  if (document !== undefined && destination !== null) {
    scrollToActiveItem(document?.getElementById(destination), handleClickNavItem);
  }
};
const scrollToActiveItem = (element, callback) => {
  const offset = element?.offsetTop - 152;
  let scrollY = -1;
  const checkIfScrollIsComplete = setInterval(() => {
    if (scrollY === window?.scrollY) {
      clearInterval(checkIfScrollIsComplete);
      callback();
    }
    scrollY = window?.scrollY;
  }, 50);
  window?.scrollTo({
    top: offset,
    left: 0,
    behavior: 'smooth'
  });
};
const toggleJumpNavExpanded = (jumpNavState, jumpNavStateUpdater) => {
  jumpNavStateUpdater(!jumpNavState);
};
exports.toggleJumpNavExpanded = toggleJumpNavExpanded;